<template>
	<div class="document page-break">
		<p style="text-align: right;">
			Приложение № {{ index }}
			<br>к Договору № {{ $root.contract.number }} от {{ $root.contract.date }}
		</p>
		<h4 class="h">Спецификация № {{ index }}</h4>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr>
						<td>1</td>
						<td>Информационно-аналитическая система «Seldon.Pro». Право использования (простая (неисключительная) лицензия сроком на {{  license_period }} месяцев.
						</td>
						<td>шт.</td>
						<td>{{ license_count }}</td>
						<td>{{ license_price }}</td>
						<td>{{ license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ license_total_sum }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<p>
				<b>Основные функциональные возможности:</b>
				<br>
				Программа для ЭВМ «Информационно-аналитическая система «Seldon.Pro»» – программный комплекс, объединяющий программы для ЭВМ и/или базы данных, а также все последующие его обновления и модификации (версии), предназначенные для использования на настольных и карманных персональных компьютерах, мобильных телефонах, коммуникаторах, смартфонах (устройства), позволяющий:
				<ol>
					<li>Получать доступ к информации о закупках России (без доступа к площадкам). В том числе к документации закупок с возможностью скачивания.</li>
					<li>Проводить мониторинг и анализ информации о закупках по заданным критериям.</li>
					<li>Проводить мониторинг и анализ ценовых предложений.</li>
					<li>Получать информацию о заказчиках и поставщиках из различных источников открытых данных, в т.ч сводных показателей, основанных на истории торгов, участие в арбитражных делах.</li>
					<li>Проводить анализ состояния рынка и его секторов в требуемых срезах (региональные, отраслевые, продуктовые).</li>
					<li>Использовать справочные аналитические модели оценки объектов, учитывающие показатели деятельности по различным критериям на основе имеющихся данных («Рекомендации закупок», «вероятность победы», «конкурентная среда» и другие).</li>
				</ol>
				<b>Минимальные технические требования:</b>
				<br>ОС: Windows, MAC, Linux
				<br>с установленным браузером:
				<br>InternetExplorer версии 10 и выше
				<br>Chrome версии 60 и выше
				<br>Firefox версии 55 и выше
				<br>Opera версии 47 и выше
				<br>Safari (Mac) версии  11 и выше
				<br>Яндекс Браузер версии 17 и выше
				<br>В браузере должен быть включен JavaScript и прием файлов cookie
				<br><br><b>Способы и порядок использования:</b>
				<br>Использование по прямому функциональному назначению на любых устройствах  в пределах количества учетных записей (рабочих мест), которое указано в настоящей Спецификации. Функциональное использование осуществляется путем доступа через Сайт размещенный по адресу https://pro.myseldon.com  с помощью пароля (уникальная последовательность символов, генерируемая программно-аппаратными средствами, и предназначенная для обеспечения возможности использования Программы, а также идентификации пользователя с целью контроля правомерности использования) и логина (указывается Сублицензиатом).
				<br><br>Сублицензиат вправе использовать Программу только согласно ее функционала исключительно работниками Сублицензиата лично, через пользовательский интерфейс Программы без использования специальных программ для ЭВМ, автоматизирующих сбор информации посредством Программы без использования пользовательского интерфейса и участия человека (далее - Роботов). 
				<br><br>Использование Сублицензиатом специальных программ для ЭВМ, автоматизирующих сбор информации посредством Программы без использования пользовательского интерфейса и участия человека, является нарушением настоящего лицензионного договора и является способом использования Программы, не предусмотренным лицензионным договором, что является основанием для одностороннего расторжения настоящего лицензионного договора по инициативе Лицензиата.
				<br><br>Лицензиат обязуется передать Сублицензиату в течение 5 (пяти) рабочих дней с момента внесения Сублицензиатом оплаты согласно п. 2.2 настоящего Договора, посредством сетей передачи данных (на электронную почту, указанную в разделе 7) средства идентификации (пароль). 
				<br>
				<br>
			</p>
		</div>
		<div>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>
							<p>
								Лицензиат
								<br>{{ $root.licentiate.short_name }}
							</p>
						</th>
						<th>
							<p>
								Сублицензиат
								<br>{{ $root.sublicentiate.short_name }}
							</p>
						</th>
					</tr>
					<tr>
						<td>
							<p>{{ $root.licentiate.position }}</p>
							<br>_________________/{{ $root.licentiate.director_short }}/
								<br>М.П.
						</td>
						<td>
							<p>{{ $root.sublicentiate.position }}</p>
							<br>_________________/{{ $root.sublicentiate.director_short }}/
								<br>М.П.
						</td>
					</tr>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		props: [
			'index',
			'license_period', 
			'license_count', 
			'license_price', 
			'license_user_count', 
			'license_total_sum'
		],
	}
</script>